import { request } from 'tools'

export const getTag = id => request.get( `tags/${id}` )